module.exports = {"experienceCloud":"Experience Cloud","touDialogCancelLabel":"内容を更新","touDialogConfirmLabel":"ログイン＆利用条件に同意","touDialogTitle":"Adobe Experience Cloud 利用条件","touTextLine1":"Adobe Experience Cloud の利用条件が更新されました。","touTextLine2a":"次にログインしてください :","touTextLine2b":"また、最新の利用条件に同意してから続行してください。","touTextLine3":"利用条件に同意した後、「内容を更新」をクリックしてください。"}


//////////////////
// WEBPACK FOOTER
// ./src/components/TermsOfUseDialog/__localization__/TermsOfUseDialog/ja_jp.json
// module id = 918
// module chunks = 0